import { useState, useEffect, useRef } from 'react';
import ProvinceSelector from './filters/provinceSelector';
import GetUniqueProvince from './data_filtering/getUniqueProvince';
import UseFetch from './useFetch';
import ThaiAndUniqueYear from './data_filtering/ThaiAndUniqueYear';
import YearSelector from './filters/yearSelector';
import TimeFormatSelector from './filters/timeFormatSelector';
import View2 from './graph/view_2_graph';
import DataFilter from './data_filtering/dataFilter_view2';
import { Row, Col, Card, Space } from 'antd';
import Legend from './graph/legend';
import { useDispatch, useSelector } from 'react-redux';
import { dateState_view2, statusState_view2, dataState_view2 } from './redux/data_view1';
import { Spin } from 'antd';
import MonthSelector from './filters/monthSelector';
import { parse } from 'papaparse';

import 'moment/locale/th';
import locale from 'antd/es/date-picker/locale/th_TH';
import ProvinceLimited from './filters/provinceLimited';
import Legend_line_shape from './graph/legend_line_shape';

import csv_1 from './data/view_2/view2_month_province.csv';
import csv_2 from './data/view_2/view2_month_country.csv';
import csv_3 from './data/view_2/view2_week_province.csv';
import csv_4 from './data/view_2/view2_week_country.csv';
import csv_5 from './data/view_2/view2_year_province.csv';
import csv_6 from './data/view_2/view2_year_country.csv';

const View_2 = () => {

    const view = 2;
    
    //data state
    const [thaiData, setThaiData] = useState(null);
    const [engData, setEngData] = useState(null);
    const [provinceData, setProvinceData] = useState(null);
    const [provinceSelectorObj, setProvinceSelectorObj] = useState(null);
    const [availableYear, setAvailableYear] = useState(null);
    const dataStream = useSelector((state) => state.data_view1.dataState.view2.data.stream);
    const streamReady = useSelector((state) => state.data_view1.dataState.view2.status.stream);
    const dateStream = useSelector((state) => state.data_view1.dataState.view2.date.stream);
    const dispatch = useDispatch();
    const [dateReady, setDateReady] = useState(false);

    // filter state
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [selectedYear, setSelectedYear] =  useState(null);
    const [selectedMonth, setSelectedMonth] =  useState(1);
    const [selectedTimeFormat, setSelectedTimeFormat] =  useState(null);

    //legend state
    const [legend, setLegend] = useState(null);

    // data stream state
    const [thaiDataStream, setThaiDataStream] = useState(null);
    const [streamAvailableYear, setStreamAvailableYear] = useState(null);
    // const [streamReady, setStreamReady] = useState(false);

    // update filtered data
    const [filteredData, setFilteredData] = useState(null);

    useEffect(() => {
        const abortCont = new AbortController();

        const { province: availableProvince, provinceObj: provinceForSelector } = GetUniqueProvince();
        setProvinceData(availableProvince);
        setProvinceSelectorObj(provinceForSelector);

        function streamResolve(url) {
            return fetch(url, {mode: 'cors', signal: abortCont.signal }).then(response => response.body)
            .then(rb => {
                const reader = rb.getReader();
              
                return new ReadableStream({
                  start(controller) {
                    // The following function handles each data chunk
                    function push() {
                      // "done" is a Boolean and value a "Uint8Array"
                      reader.read().then( ({done, value}) => {
                        // If there is no more data to read
                        if (done) {
                          console.log('view 2 done', done);
                          controller.close();
                          return;
                        }
                        // Get the data and send it to the browser via the controller
                        controller.enqueue(value);
                        // Check chunks by logging to the console
                        //console.log(done, value);
                        push();
                      })
                    }
              
                    push();
                  }
                });
              })
              .then(stream => {
                // Respond with our stream
                return new Response(stream, { headers: { "Content-Type": "application/json" } });
              })
              .then(result => {
                // Do things with result
                return result;
              });

          }

        if(streamReady === false){

            Promise.all([
                streamResolve(csv_1).then(resp => resp.text()),
                streamResolve(csv_2).then(resp => resp.text()),
                streamResolve(csv_3).then(resp => resp.text()),
                streamResolve(csv_4).then(resp => resp.text()),
                streamResolve(csv_5).then(resp => resp.text()),
                streamResolve(csv_6).then(resp => resp.text()),
                // streamResolve(base+path.month.province).then(resp => resp.json()),
                // streamResolve(base+path.month.whole).then(resp => resp.json()),
                // streamResolve(base+path.week.province).then(resp => resp.json()),
                // streamResolve(base+path.week.whole).then(resp => resp.json()),
                // streamResolve(base+path.year.province).then(resp => resp.json()),
                // streamResolve(base+path.year.whole).then(resp => resp.json())
            ])
                .then(data => {
                    const jsonData = [];
                    const label = ['view_2_month_province', 'view_2_month_whole',
                    'view_2_week_province','view_2_week_whole',
                    'view_2_year_province','view_2_year_whole'];
                    data.forEach((d,i) => {
                        let obj = {};
                        let d_parse = parse(d,{header: true, dynamicTyping: true, skipEmptyLines:true});
                        obj[label[i]] = d_parse.data;
                        jsonData.push(obj);
                    })
                    const {ThaiData, uniqueDate} = ThaiAndUniqueYear(jsonData, view, true);
                    setThaiDataStream(ThaiData);
                    setStreamAvailableYear(uniqueDate);

                    dispatch(dateState_view2([uniqueDate,2]));
                    dispatch(dataState_view2([ThaiData,2]));
                    dispatch(statusState_view2(2));

                }).catch(err => {
                    if(err.name === 'AbortError'){
                        console.log('fetch aborted');
                    }
                });
        } else {
            setThaiData(dataStream);
        }
        return () => abortCont.abort();
     }, []);

    useEffect(() => {
        if(streamReady === true && dataStream !== undefined){
            setThaiData(dataStream);
            setAvailableYear(dateStream);
            setDateReady(true);
        } else {
            dispatch(dateState_view2([availableYear,2]));
            dispatch(dataState_view2([thaiData,2]));
        }
    }, [streamReady]);

    useEffect(() => { 
        const { dataFilter: filtered } = DataFilter(thaiData, selectedYear, selectedMonth, selectedTimeFormat,selectedProvince,view, streamReady);
        setFilteredData(filtered);
    }, [selectedYear,selectedMonth,selectedTimeFormat,selectedProvince]);

    return ( 
        <div>
            <Row>
                <Row>
                    <div className="filter">
                        {streamReady &&
                        < Space direction="horizontal">
                            <Col  span={7}>
                                <Card bordered={false} className="filter-container" type="inner" size="small" style={{ width: 200 }}>
                                    <p class="filter-title">จังหวัดเพื่อเปรียบเทียบ</p>
                                    <div className="filter" >
                                        < ProvinceLimited onChange={(value) => setSelectedProvince(value)} />
                                    </div>
                                </Card>
                            </Col>
                            <Col  span={1}>
                            </Col>
                            <Col  span={7}>
                                {selectedTimeFormat != "ปี" && <Card bordered={false} className="filter-container" type="inner" size="small" style={{ width: 200 }}>
                                    <p class="filter-title">ปี และ เดือน</p>
                                    <div className="filter" >
                                        {dateReady && < MonthSelector onChange={(selectedYear,selectedMonth) => {
                                        setSelectedYear(selectedYear);
                                        setSelectedMonth(selectedMonth);
                                        }} 
                                        locale={locale} availableYear={availableYear} streamReady={streamReady} view={view}/>}
                                    </div>
                                </Card> }
                            </Col>
                            <Col  span={1}>
                            </Col>
                            <Col  span={7}>
                                <Card bordered={false} className="filter-container" type="inner" size="small" style={{ width: 200 }}>
                                    <p class="filter-title">รูปแบบของเวลา</p>
                                    <div className="filter" >
                                        < TimeFormatSelector onChange={(value) => setSelectedTimeFormat(value)} streamReady={streamReady}/>
                                    </div>
                                </Card> 
                            </Col>
                            <Col  span={1}>
                            </Col>
                        </ Space >
                        }
                    </div>
                </Row>
                <Row>
                    <div className="graph">
                        <h2 className="graph-title">การตายส่วนเกิน (Excess Death)</h2>
                        < View2 onChange={(value) => setLegend(value)} graphData={filteredData} selectedTimeFormat={selectedTimeFormat}
                        selectedYear={selectedYear} selectedMonth={selectedMonth} availableYear={availableYear}/>
                        { !streamReady && <Space className="spinner" size="middle">
                            <Spin size="large" />
                            {!streamReady && !thaiData && <p className="loadText">Loading Data...</p>}
                            {!streamReady && thaiData && <p className="loadText_2">Get Data Completed</p>}
                        </Space>}
                    </div>
                    <Row>
                        <Col  span={1}></Col>
                        <Col  span={11}>
                            <div className="legend">
                                {filteredData && legend &&<p>คำอธิบาย (ประเภทเส้นกราฟ)</p>}
                                {filteredData && legend && <Legend_line_shape view={view}/>}
                            </div>
                        </Col>
                        <Col  span={1}></Col>
                        <Col  span={11}>
                            <div className="legend">
                                {filteredData && legend &&<p>คำอธิบาย (สี - จังหวัด)</p>}
                                {filteredData && legend && <Legend legend={legend} view={view}/>}
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Row>
        </div>

     );
}
 
export default View_2;